module.exports = __webpack_public_path__ + "static/iphone-mirror-0cd701d325c50459154d82fe7f35f71a.png";